/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

module.exports = '15.6.1';


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-sweetalert/~/react-redux/~/react/lib/ReactVersion.js
// module id = ./node_modules/react-redux-sweetalert/node_modules/react-redux/node_modules/react/lib/ReactVersion.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons